function Navigation_admin_toggle_all(element) {
  this.$element = element;

  this.toggled = false;

  this.selectors = {
    body: 'body', // eventbus
  };

  this.triggers = {
    expand:   'i4-navigation:toggle-expand-all',
    collapse: 'i4-navigation:toggle-collapse-all',
  };

  this.init = function() {
    // console.log('init - Navigation_admin_toggle_all');

    this.$body = $(this.selectors.body);

    // button click -> fire toggle all event on eventbus
    this.$element.addEventListener('click', () => {
      if (!this.toggled) {
        this.$body.trigger(this.triggers.expand);
        this.toggled = true;
      } else {
        this.$body.trigger(this.triggers.collapse);
        this.toggled = false;
      }
    });
  };
}

function Navigation_admin_toggle(element) {
  this.$element = element;

  this.$sub_navlist = null;

  this.toggled = false;

  this.selectors = {
    body: 'body', // eventbus
    node: '.a-navigation__manage-list-node',
    list: '.a-navigation__manage-list'
  };

  this.triggers = {
    expand:   'i4-navigation:toggle-expand-all',
    collapse: 'i4-navigation:toggle-collapse-all',
  };


  this.init = function() {
    // console.log('init - Navigation_admin_toggle');

    var self_navnode = this.$element.closest(this.selectors.node);
    if (self_navnode) {
      this.$sub_navlist = self_navnode.querySelector(this.selectors.list);
    }

    if (!this.$sub_navlist) {
      // visually hide the button element but keep it's space so that the nav items on the same level appear in one line
      this.$element.style.opacity = 0;
      this.$element.style.pointerEvents = 'none';
      return;
    }

    // button click toggle
    this.$element.addEventListener('click', () => {
      if (!this.toggled) {
        this.expand();
      } else {
        this.collapse();
      }
    });

    // expand / collapse all toggle button click via eventbus
    this.$body = $(this.selectors.body);
    this.$body.on(this.triggers.expand, this.expand.bind(this));
    this.$body.on(this.triggers.collapse, this.collapse.bind(this));
  };

  this.expand = function () {
    if (!this.toggled) {
      this.$element.classList.add('toggled');
      this.$sub_navlist.classList.add('toggled');
      this.toggled = true;
    }
  };

  this.collapse = function () {
    if (this.toggled) {
      this.$element.classList.remove('toggled');
      this.$sub_navlist.classList.remove('toggled');
      this.toggled = false;
    }
  };
}
